import React from "react";
import { connect } from "react-redux";
import compose from "../../../utils/compose";

import { changeRhGraphSettings, prepareDataForSave } from "../../../redux/actions/report-actions";
import getSubfragm from "../../../graphics/get-subfragm";
import withSignalGetter from "../../../hoc/with-signal-getter";

import { MagnifierX, MagnifierY } from "../../magnifier";

import { Spinner /*ErrorIndicator*/ } from "../../state-indicators";
import ECGGraphSVG, { rhythmGraphSettings } from "../../../graphics/svg/ecg-graph-svg";
import uuid from "../../../utils/uuid";
import getDiffProperties from "../../../utils/getDiffProperties";

import "./graph-rhythm.scss";
class GraphRhythm extends React.Component {
    _mounted = false;
    state = {
        loading: true,
        error: false,

        zoomXInDisabled: false,
        zoomXOutDisabled: false,
        zoomYInDisabled: false,
        zoomYOutDisabled: false
    };
    ms_pnt = val => (val === undefined || val === null || val === "" ? null : Math.round((val * this.props.signal.fd) / 1000));
    componentDidUpdate(prevProps) {
        const {
            scale: { timeScale_mm_s: timeScale_mm_s_p, voltageScale_mm_mV: voltageScale_mm_mV_p, channel: channel_p },
            signalFilters: filters_p,
            lang: lang_p
        } = prevProps;
        const {
            scale: { timeScale_mm_s, voltageScale_mm_mV, channel },
            signalFilters: filters,
            lang
        } = this.props;

        if (
            channel_p !== channel ||
            timeScale_mm_s_p !== timeScale_mm_s ||
            voltageScale_mm_mV_p !== voltageScale_mm_mV ||
            lang_p !== lang ||
            JSON.stringify(filters) !== JSON.stringify(filters_p)
        )
            this.drawGraph();

        if (timeScale_mm_s_p !== timeScale_mm_s)
            this.setState({
                zoomXInDisabled: timeScale_mm_s >= this.xScales[this.xScales.length - 1],
                zoomXOutDisabled: timeScale_mm_s <= this.xScales[0]
            });

        if (voltageScale_mm_mV_p !== voltageScale_mm_mV)
            this.setState({
                zoomYInDisabled: voltageScale_mm_mV >= this.yScales[this.yScales.length - 1],
                zoomYOutDisabled: voltageScale_mm_mV <= this.yScales[0]
            });
    }
    componentDidMount() {
        const {
            scale: { timeScale_mm_s, voltageScale_mm_mV }
        } = this.props;
        const zoomDisabled = {
            zoomXInDisabled: timeScale_mm_s >= this.xScales[this.xScales.length - 1],
            zoomXOutDisabled: timeScale_mm_s <= this.xScales[0],
            zoomYInDisabled: voltageScale_mm_mV >= this.yScales[this.yScales.length - 1],
            zoomYOutDisabled: voltageScale_mm_mV <= this.yScales[0]
        };
        this.setState(zoomDisabled);
        this._mounted = true;
        this.drawGraph();
    }
    componentWillUnmount() {
        this._mounted = false;
    }

    drawGraph() {
        // Data
        let {
            scale: { timeScale_mm_s, channel },
            Q,
            S,
            signal: { signalLength, fd, channelNames, reportFragmStart_pnt },
            complexes,
            prepared,
            stimulator,
            stimPositions
        } = this.props;
        if (Q === null || Q === undefined || !prepared) {
            this.drawSVG();
            this.setState({ error: false, loading: false });
            return;
        }

        Q = this.ms_pnt(Q);
        S = this.ms_pnt(S);

        // Fragment start length
        const length180mm = (180 / timeScale_mm_s) * fd;
        const { start, length } = getSubfragm(signalLength, Math.round(Q + S / 2), length180mm);

        // Cmpxs
        const cmpxs = complexes.Qs.map((v, i) => {
            return { Q: v + reportFragmStart_pnt - start, S: v + reportFragmStart_pnt + complexes.Ws[i] - 1 - start };
        }).filter(cmpx => cmpx.Q >= 0 && cmpx.S <= length);

        // Область представительного комплекса
        const areaStart = Q - start - 0.25 * fd,
            areaWidth = S + 2 * 0.25 * fd;

        // Get signal
        if (!this._mounted) {
            return;
        }

        // let req = stimulator ? this.props.signalService.reqSignalWithStimulus(start, length) : this.props.reqSignal(start, length);
        let req = this.props.reqSignal(start, length);

        req.then(_data => {
            if (!this._mounted) {
                return;
            }
            let data = [];

            if (_data.signal) {
                const ptsQty = _data.signal[0].length;
                for (let i = 0; i < ptsQty; i++) {
                    data[i] = _data.signal[channel][i] / 1000;
                }
            }

            const signal = {
                data_mV: data,
                fd,
                chQty: 1,
                ptsQty: data.length,
                channelNames: channelNames[channel]
            };
            let ticks = [{ X_pts: [...cmpxs.map(v => v.Q), ...cmpxs.map(v => v.S)] }];
            ticks = undefined; // Отключено

            const highlightAreas = {
                X_pnt: areaStart,
                Y_bottom_mm: 0,
                height_mm: 1,
                width_pts: areaWidth,
                color: "#888888"
            };

            let backgroundLines;
            // TODO Make UI settings to disable stim marks on graph
            const showStimOnGraph = false;
            if (showStimOnGraph && stimulator && stimPositions) {
                const stims = stimPositions.filter(st => st >= start && st < start + length);
                backgroundLines = {
                    X_pts: stims.map(x => x - start),
                    Y_mm: 0,
                    height_mm: rhythmGraphSettings.graphSetts.height_mm - 1, // -1 тк в высоте полотна был заложен дополнительный мм
                    color: "#6d75768c", //"#0BB2BC",
                    width_mm: 0.5
                };
            }

            if (this.svgcontainer) {
                this.drawSVG({ signal, backgroundLines, highlightAreas, ticks });
            }

            this.setState({ signalData: data, start, error: false, loading: false });
        }).catch(error => {
            if (!this._mounted) {
                return;
            }

            if (this.svgcontainer) {
                this.svgcontainer.innerText = "";
                this.drawSVG();
            }
            this.setState({ error: true, loading: false });
            console.error(error);
        });
    }

    drawSVG = ({ signal, backgroundLines, highlightAreas, ticks } = {}) => {
        const {
            loc,
            scale: { timeScale_mm_s, voltageScale_mm_mV }
        } = this.props;
        this.svgcontainer.innerText = "";
        const setts = rhythmGraphSettings;
        setts.plotSetts.ScaleX_mm_sec = timeScale_mm_s;
        setts.plotSetts.ScaleY_mm_mV = voltageScale_mm_mV;
        const SvgECG = new ECGGraphSVG("RhythmECGGraph", setts);

        const svg = SvgECG.draw({ signal, highlightAreas, backgroundLines, ticks, time_scale_str: loc("units.mm_sec") });
        this.svgcontainer.appendChild(svg);
    };

    prepareZoomChangesSaving = sett => {
        const {
            prepareDataForSave,
            scale: { timeScale_mm_s, voltageScale_mm_mV }
        } = this.props;
        let prepared = {};
        let { diff, same } = getDiffProperties(
            { graphReprCmpx_timeScale_mm_s: timeScale_mm_s, graphReprCmpx_voltageScale_mm_mV: voltageScale_mm_mV },
            sett
        );
        diff.forEach(({ key, val }) => {
            if (val !== undefined) prepared[key] = val;
        });
        prepareDataForSave({ diff: prepared, same });
    };
    xScales = [10, 25, 50];
    yScales = [5, 10, 20];
    xZoomIn = () => {
        const {
            changeSettings,
            scale: { timeScale_mm_s }
        } = this.props;
        const newScale = this.xScales.find(_v => _v > timeScale_mm_s);
        if (newScale) {
            changeSettings({
                timeScale_mm_s: newScale
            });
            this.prepareZoomChangesSaving({
                graphRhythm_timeScale_mm_s: newScale
            });
        }
    };
    xZoomOut = () => {
        const {
            changeSettings,
            scale: { timeScale_mm_s }
        } = this.props;
        const newScale = this.xScales
            .slice()
            .reverse()
            .find(_v => _v < timeScale_mm_s);
        if (newScale) {
            changeSettings({
                timeScale_mm_s: newScale
            });
            this.prepareZoomChangesSaving({
                graphRhythm_timeScale_mm_s: newScale
            });
        }
    };
    yZoomIn = () => {
        const {
            changeSettings,
            scale: { voltageScale_mm_mV }
        } = this.props;
        const newScale = this.yScales.find(_v => _v > voltageScale_mm_mV);

        if (newScale) {
            changeSettings({
                voltageScale_mm_mV: newScale
            });
            this.prepareZoomChangesSaving({
                graphRhythm_voltageScale_mm_mV: newScale
            });
        }
    };
    yZoomOut = () => {
        const {
            changeSettings,
            scale: { voltageScale_mm_mV }
        } = this.props;
        const newScale = this.yScales
            .slice()
            .reverse()
            .find(_v => _v < voltageScale_mm_mV);
        if (newScale) {
            changeSettings({
                voltageScale_mm_mV: newScale
            });
            this.prepareZoomChangesSaving({
                graphRhythm_voltageScale_mm_mV: newScale
            });
        }
    };
    onChannelChanged = selectedChannel => {
        this.props.changeSettings({ channel: selectedChannel.index });
        this.prepareZoomChangesSaving({
            graphRhythm_channel: selectedChannel.index
        });
    };
    render() {
        const {
            popupable,
            signal: { channelNames },
            scale: { channel }
        } = this.props;
        const { loading, error, zoomXInDisabled, zoomXOutDisabled, zoomYInDisabled, zoomYOutDisabled } = this.state;
        const { xZoomIn, xZoomOut, yZoomIn, yZoomOut } = this;
        const options = channelNames.map(name => (
            <option value={name} key={uuid()}>
                {name}
            </option>
        ));
        return (
            <div className={"report-graph report-graph-rhythm " + (error ? " error" : "") + (popupable ? " popup-able" : "")}>
                <div
                    ref={_self => {
                        this.svgcontainer = _self;
                    }}
                    style={{ textAlign: "center" }}
                />

                <select
                    className="ctrl-input graph-selector__Lead"
                    value={channelNames[channel]}
                    onChange={({ target: { selectedIndex: index, value: title } }) => this.onChannelChanged({ index, title })}>
                    {options}
                </select>
                <MagnifierX zoomIn={xZoomIn} zoomOut={xZoomOut} disableOut={zoomXOutDisabled} disableIn={zoomXInDisabled} />
                <MagnifierY zoomIn={yZoomIn} zoomOut={yZoomOut} disableOut={zoomYOutDisabled} disableIn={zoomYInDisabled} />
                {/* <div style={{ height: "100%", width: "100%" }} ref={_self => this.canvasWrap = _self}/> */}

                {
                    //  error ? <ErrorIndicator verySmall withCaption {...{ errorCaptionKey: "errors.dataUnavailable" }} /> :
                    loading ? <Spinner small transparent /> : null
                }
            </div>
        );
    }
}
const mapDispathToProps = {
    changeSettings: changeRhGraphSettings,
    prepareDataForSave
};
const mapStateToProps = ({
    reportApp: {
        reportData: {
            report: { representativeCmpx, complexes, stimulator, stimPositions, signal },
            settings: {
                graphs: { graphRhythm: scale, signalFilters }
            }
        }
    }
}) => {
    let Q, S;
    if (representativeCmpx) ({ Q, S } = representativeCmpx);

    return {
        scale,
        Q: Q?.val,
        S: S?.val,
        complexes,
        signal,
        signalFilters,
        stimulator,
        stimPositions
    };
};
export default compose(withSignalGetter, connect(mapStateToProps, mapDispathToProps))(GraphRhythm);
